
import TixTemplate from '@/components/elements/TixTemplate.vue'
import type { LanguageStrings } from '@/language/types'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'LoginFlowStepOTPUnavailable',
  components: { TixTemplate },
})
export default class extends Vue {
  t: LanguageStrings['loginFlowStepOTPUnavailable']
  otp: string = ''
  copied: boolean = false

  created() {
    const isFromMagicLink = this.$route.query.otp

    if (isFromMagicLink) {
      this.otp = this.$route.query.otp

      // remove query param from url
      const { otp, ...query } = this.$route.query
      this.$router.replace({ query })
      delete window.tixAppState?.queryParams?.otp
    }
  }

  async copyToClipboard() {
    await navigator.clipboard.writeText(this.otp)
    this.copied = true
  }

  get iconName() {
    return this.copied ? 'CheckmarkIcon' : 'CopyIcon'
  }

  get copyText() {
    return this.copied ? this.t.copiedText : this.t.copyText
  }
}
